<template>
  <main>
    <Works />
  </main>
</template>

<script>
import Works from "@/components/Works.vue";

export default {
  name: "Neoprene",
  components: {
    Works
  },
  beforeCreate: function() {
    this.$store.commit("setSelected", 6);
  }
};
</script>
